'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A wrapper component for bootstrap form adding accessibility support. Accepts
 * all react-bootstrap's form props.
 *
 * @example
 * <Form horizontal	className="edit-fields"	onSubmit={this.props.onSubmit}>
 * 		<FormGroup />
 * 		<FormGroup />
 * </Form>
 */
var Form = function (_React$Component) {
	_inherits(Form, _React$Component);

	function Form() {
		_classCallCheck(this, Form);

		return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	}

	_createClass(Form, [{
		key: 'render',
		value: function render() {
			var _onSubmit = this.props.onSubmit;

			return _react2.default.createElement(
				_reactBootstrap.Form,
				_extends({}, this.props, {
					onSubmit: function onSubmit(e) {
						e.preventDefault();
						return _onSubmit && _onSubmit();
					}
				}),
				this.props.children,
				_react2.default.createElement('input', { type: 'submit', className: 'invisible', value: '' })
			);
		}
	}]);

	return Form;
}(_react2.default.Component);

Form.propTypes = {
	/**
  * Form submit handler to support form submission on Return key press.
  */
	onSubmit: _propTypes2.default.func
};

var _default = Form;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Form, 'Form', 'src/components/Form.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/Form.jsx');
}();

;